<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeMoisComptable.filtre.exercices')">
            <qd-taginput
              v-model="critereRecherche.exercices"
              :data="filteredTagsExercice"
              @typing="getfilteredTagsExercice"
              @input="getExerciceTags"
              field="code"
              type="is-primary"
              icon="magnify"
              autocomplete
              open-on-focus>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeMoisComptable.filtre.etats')"
                        :items="constantes.MOIS_COMPTABLE_TYPE"
                        v-model="critereRecherche.etats">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeMoisComptable.filtre.periode')">
            <div class="columns is-vcentered" >
              <b-datepicker
                show-week-number
                class="column"
                icon="calendar-today"
                :editable="true"
                v-model="critereRecherche.periode.dateDebut"
                :nearby-selectable-month-days="true">
              </b-datepicker>
              <span class="column is-1">
                {{$t('listeMoisComptable.filtre.au')}}
              </span>
              <b-datepicker
                show-week-number
                class="column"
                icon="calendar-today"
                :editable="true"
                v-model="critereRecherche.periode.dateFin"
                position="is-bottom-left"
                :nearby-selectable-month-days="true">
              </b-datepicker>
            </div>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/presse/moisComptable/genererCritereRecherche';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/presse/moisComptable-mutation-type';
import { MOIS_COMPTABLE_TYPE } from '@/configuration/presse/presseConfig';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const MoisComptable = createNamespacedHelpers('moisComptable');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      critereRecherche: null,
      filteredTagsExercice: [],
      constantes: {
        MOIS_COMPTABLE_TYPE,
      },
    };
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...MoisComptable.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    exercices() {
      return this.parametre(PARAMETRES_KEYS.exercice);
    },
  },
  methods: {
    ...MoisComptable.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getExerciceTags() {
      this.filteredTagsExercice = this.exercices
        .filter((option) => {
          return !this.critereRecherche.exercices
            .map(e => e.id).includes(option.id);
        });
    },
    getfilteredTagsExercice(text) {
      this.getExerciceTags();
      this.filteredTagsExercice = this.filteredTagsExercice.filter((option) => {
        return option.code.toString().toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    viderCritere() {
      const critereRecherche = genererCritereRecherche();
      this.critereRecherche = critereRecherche;
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([PARAMETRES_KEYS.exercice]);
        this.getExerciceTags();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
